<template>
<div>
    <div>
        <input type="checkbox" id="showmenu" class="d-none" name="showmenu" value="">
        <nav class="navbar navbar-expand-lg justify-content-between fixed-top" id="mainnavselection">
            <!-- logo and menu icon -->
            <span>
                <a class="navbar-brand" href="/">
                    <img src="favicon.png" alt="" style="height: 40px; margin-right: 5px;"/>
                    <span style="font-weight: 600; font-size: 1rem; color: #381364">
                        Phable.me
                    </span>
                </a>
            </span>
            <!--
                <label class="navbar-toggler ml-auto" for="showmenu">
                    Menu <span class="material-icons ico">sort</span>
                </label>
            -->
            <a href="/login" class="btn btn-outline-primary ml-4">Inloggen</a>
        </nav>
    </div>
    <div class="vh100 d-flex" id="top">
        <div class="text-center fullheight center-items flex-center" style="flex: 1;">
            <div class="container">
                <div id="hero_unit">
                    <div>
                      <h1 class="display-4 mb-2">Phable.me</h1>
                      <p class="mb-3">
                        Online leren. Lekker simpel.
                      </p>
                      <transition name="fade">
                        <div class="alert mw-500px mr-auto ml-auto" v-if="msgtext" :class="msgclass" v-html="msgtext"></div>
                      </transition>
                      <button v-if="!createlesson && !entercode" :disabled="loading" @click.prevent="entercode = true" class="btn btn-lg btn-primary m-1">Ik heb een code</button>
                      <button v-if="!createlesson && !entercode" :disabled="loading" @click.prevent="createlesson = true" class="btn btn-lg btn-outline-primary m-1">Ik wil een les aanmaken</button> 
                      <transition name="fade">
                        <form @submit.prevent="createSite()" id="create-site" v-if="createlesson">
                          <input type="email" @input="msgtext = ''" placeholder="Jouw e-mail..." name="user-email" v-model="username" class="form-control mr-3" autofocus>
                          <button name="submit-create-site" :disabled="loading" class="btn btn-lg btn-primary">  
                            <loader v-if="loading" style="margin-bottom: -10px;"/><span v-if="!loading">Maak les aan</span>
                          </button>
                        </form>
                        <form @submit.prevent="checkCode()" id="give-code" v-if="entercode">
                          <input type="text" @input="msgtext = ''" placeholder="Bijv: P9FX3M" v-model="enteredcode" class="form-control mr-3" autofocus>
                          <button name="submit-create-site" :disabled="loading" class="btn btn-lg btn-primary">  
                            <loader v-if="loading" style="margin-bottom: -10px;"/><span v-if="!loading">Doorgaan</span>
                          </button>
                        </form>
                      </transition>
                      <p class="text-muted mt-3">
                        Probeer het 1 maand gratis uit
                      </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import MainNav from '../components/navigation/MainNav.vue';
  import MainFooter from '../components/navigation/MainFooter.vue';
  import SectionBlock from '../components/content/SectionBlock.vue';
  import PageAdder from '../components/app/PageAdder.vue';
  
  import axios from 'axios';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';

  export default {
    props:{
      content: {
        type: Object
      },
      homeimage: {
          type: String
      }
    },
    data: function (){
      return {
        createlesson: false,
        entercode: false,
        enteredcode: '',
        readonly: false,
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        loggingin: false,
        returnUrl: '',
        error: '',
        pages: {},
        websiteid: process.env.VUE_APP_ROOT_ID,
        phabsiteid: '9t6tmaV5vz9f1Su',
        selectedtheme: 'default',
        mainpageid: 'home'
      }
    },
    created () {

      // get return url from route parameters or default to '/'
      this.returnUrl = this.$route.query.returnUrl || '/';
    },
    components: {
      InputDefault,
      AlertBar,
      Loader,
      MainNav,
      PageAdder,
      MainFooter,
      SectionBlock
    },
    methods: {
      createSite(){

          if(!this.username){
            this.msgtext = 'Geef een emailadres op om een les te beginnen.'
            this.loading = false
            return
          }
          const data = {
            email: this.username
          }

          this.loading = true
          
          // reset login status
          userService.logout();

          axios.post(process.env.VUE_APP_ROOT_API+'/users/', data)
          .then(
            response => {
              localStorage.setItem('user', JSON.stringify(response.data));
              window.location.href = '/user'
            },
            error => {
              this.loading = false
              this.msgtext = 'Dit emailadres is al in gebruik. Je kunt ook <a href="/login">inloggen</a> met dit emailadres.'
            }
          )
      },
      checkCode(){
          axios.get(process.env.VUE_APP_ROOT_API+'/settings/checkcode/'+this.enteredcode)
          .then(
            response => {
              window.location.href = '/lesson/'+this.enteredcode
            },
            error => {
              alert('doesnt')
            }
          )
      }
    },
    mounted(){
    }
  }
</script>

<style>
</style>
